var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33336 12.1564H18.6666V9.12742H1.33336V12.1564ZM3.11047 7.82923H9.33239V4.79927H3.11047V7.82923ZM10.6667 7.82923H16.8885V4.79927H10.6667V7.82923ZM5.1105 2.20295H14.8886C15.7581 2.20295 16.499 2.74498 16.7743 3.50108H3.22475C3.49999 2.74498 4.24193 2.20295 5.1105 2.20295ZM18.2219 4.15067C18.2219 2.36048 16.7267 0.904762 14.8886 0.904762H5.1105C3.27241 0.904762 1.77717 2.36048 1.77717 4.15067V7.82923H0V17.0952H1.33336V13.4546H18.6666V17.0952H20V7.82923H18.2219V4.15067Z",
    fill: "#69757C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.3260ee010567b55df150b9c6ca220fe7.svg";
export { ForwardRef as ReactComponent };